import React from "react";
import { OrderPaymentMethodApi } from "../../../../../../../../services/Api/Public/types";
import OrderPaymentMethod from "../../../Payment/components/Payments/OrderPaymentMethod";

interface Props {
	paymentMethods: OrderPaymentMethodApi[];
}

const OrderFooterPaymentMethods = ({ paymentMethods }: Props) => {
	if (paymentMethods.length === 0) return <></>;

	const uniquePaymentMethodTypes = paymentMethods.filter(
		(paymentMethod, index, self) => index === self.findIndex((item) => item.type === paymentMethod.type)
	);

	return (
		<div
			className="d-flex gap-2 flex-wrap w-100 justify-content-center mt-2 opacity-50"
			data-testid="e-order-footer-payment-methods"
		>
			{uniquePaymentMethodTypes.map((paymentMethod) => (
				<OrderPaymentMethod
					paymentMethodType={paymentMethod.type}
					key={`${paymentMethod.id}-${paymentMethod.type}`}
				/>
			))}
		</div>
	);
};

export default OrderFooterPaymentMethods;
